import { Link } from 'react-router-dom';
import Photo1 from '../../assets/imgs/photos/photo-1.webp';
import Photo1Sm from '../../assets/imgs/photos/photo-1-800.webp';
import Photo2 from '../../assets/imgs/photos/photo-2.webp';
import Photo2Sm from '../../assets/imgs/photos/photo-2-800.webp';
import { ArrowRight } from 'lucide-react';
import ClickableImage from '../../components/ClickableImage';

const Community = () => {

  return <section className='bg-empty'>
    <div className="flex-col lg:flex-row flex items-center px-10 py-20 gap-20">
      <div className="basis-1/2 w-full grid grid-cols-1 lg:grid-cols-2 gap-10">
        <ClickableImage
          src={Photo2}
          srcSet={`${Photo2Sm} 800w, ${Photo2} 1600w`}
          sizes="(min-width: 1024px) 25vw, 90vw"
          className="w-full lg:h-80 object-cover"
          alt="Attività del branco"
          width={1600}
          height={1201}
          loading="lazy"
        />
        <ClickableImage
          src={Photo1}
          srcSet={`${Photo1Sm} 800w, ${Photo1} 1600w`}
          sizes="(min-width: 1024px) 25vw, 90vw"
          className="w-full lg:h-80 object-cover"
          alt="Attività del reparto"
          width={1600}
          height={1067}
          loading="lazy"
        />
      </div>
      <div className='w-full flex flex-col basis-1/2 gap-5 text-white'>
        <h2 className='text-3xl'>Acireale 6: una comunità attiva</h2>
        <p>Ciao a tutti! Siamo l'Acireale 6, un gruppo scout che vuole fare la differenza nella propria comunità.</p>
        <Link className='text-lg hover:underline flex items-center' to={'/gruppo'}>
          Scopri di più
          <ArrowRight className='ml-2' aria-hidden="true" />
        </Link>
      </div>
    </div>
  </section>;
};

export default Community;
